import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { FormHelperText } from "@mui/material";
import dohvatiVrijednostPolja from "../../../utils/dohvatiVrijednostPolja";

const Index = ({ nazivPolja }: any) => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <FormHelperText
      error
      id={`${nazivPolja}-error-message`}
      sx={{ marginLeft: 0 }}
    >
      {dohvatiVrijednostPolja(errors, `${nazivPolja}.message`)}
    </FormHelperText>
  );
};

export default Index;
